export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe49d2cde652a933e72e8bf085adeeca59186f546&name=fetchTypeahead!'